import axios from "axios";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { LoadingContainer } from "./Home/Components/HomeScreen/styles";
import { CircularProgress } from "@mui/material";

const GoogleAuth = () => {
  const { hash } = useLocation();

  const handleLogin = ({ idToken = "" }) => {
    let req = {
      method: "POST",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/authenticate/google",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        idToken,
      },
    };

    axios(req).then((res) => {
      console.log(res);
      window.localStorage.setItem("Token", res.data.id_token);
      window.location.assign("/Home");
    });
  };

  useLayoutEffect(() => {
    const idToken = new URLSearchParams(hash.replace("#", "")).get("id_token");

    if (idToken) {
      handleLogin({ idToken });
    }
  }, [hash]);

  return (
    <LoadingContainer>
      <CircularProgress size={24} />
    </LoadingContainer>
  );
};

export default GoogleAuth;
